
export const communityCategories = [
  { id: 'all', name: '전체', count: 156 },
  { id: 'free', name: '자유게시판', count: 68 },
  { id: 'tips', name: '꿀팁공유', count: 34 },
  { id: 'review', name: '업장후기', count: 28 },
  { id: 'qna', name: '질문답변', count: 18 },
  { id: 'news', name: '업계소식', count: 8 },
];

export const communityPosts = [
  {
    id: 'post-001',
    category: 'tips',
    categoryName: '꿀팁공유',
    title: '신입 바텐더가 알아야 할 칵테일 기본기 10가지',
    content: '안녕하세요, 5년차 바텐더입니다. 처음 이 업계에 들어오시는 분들을 위해 꼭 알아야 할 기본기를 정리해봤어요. 쉐이킹, 스터링, 빌드 등 기본 테크닉부터 자주 쓰는 레시피까지 한번에 정리했습니다.',
    author: '칵테일마스터',
    authorAvatar: 'https://public.readdy.ai/ai/img_res/536c49801c3eeb17cf185cac22dd243e.jpg',
    createdAt: '2025-07-04 14:30',
    views: 3842,
    comments: 47,
    likes: 128,
    isHot: true,
    image: 'https://readdy.ai/api/search-image?query=colorful%20cocktail%20making%20process%20bartender%20hands%20shaking%20cocktail%20shaker%20dark%20bar%20background%20warm%20ambient%20lighting%20professional%20mixology&width=600&height=360&seq=comm-1&orientation=landscape',
  },
  {
    id: 'post-002',
    category: 'free',
    categoryName: '자유게시판',
    title: '강남 쪽 분위기 좋은 매장 추천 부탁드려요',
    content: '이번에 이직을 생각하고 있는데, 강남 쪽에서 분위기 좋고 직원 대우 괜찮은 매장 있으면 추천 부탁드립니다. 현재 2년차 서버로 일하고 있습니다.',
    author: '이직고민중',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20professional%20woman%20portrait%20casual%20style%20warm%20smile%20soft%20lighting%20headshot%20photo%20dark%20background&width=80&height=80&seq=avatar-2&orientation=squarish',
    createdAt: '2025-07-04 12:15',
    views: 1256,
    comments: 23,
    likes: 34,
    isHot: false,
    image: null,
  },
  {
    id: 'post-003',
    category: 'review',
    categoryName: '업장후기',
    title: '라운지 퍼플 3개월 근무 솔직 후기',
    content: '라운지 퍼플에서 3개월 정도 일했는데 솔직한 후기 남깁니다. 급여는 업계 평균 이상이고, 팁도 꽤 괜찮은 편이에요. 다만 주말에는 정말 바쁘고 체력적으로 힘들 수 있습니다. 전반적으로 추천합니다.',
    author: '퍼플러버',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20with%20stylish%20hair%20casual%20outfit%20warm%20expression%20soft%20lighting%20headshot%20dark%20background&width=80&height=80&seq=avatar-3&orientation=squarish',
    createdAt: '2025-07-03 22:40',
    views: 2567,
    comments: 56,
    likes: 89,
    isHot: true,
    image: null,
  },
  {
    id: 'post-004',
    category: 'qna',
    categoryName: '질문답변',
    title: '처음 면접 보는데 어떤 옷 입고 가야 하나요?',
    content: '다음 주에 모던바 면접이 잡혔는데, 어떤 복장으로 가야 할지 모르겠어요. 정장? 캐주얼? 선배님들 조언 부탁드립니다!',
    author: '면접준비생',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20person%20portrait%20nervous%20expression%20casual%20style%20soft%20warm%20lighting%20headshot%20photo%20dark%20background&width=80&height=80&seq=avatar-4&orientation=squarish',
    createdAt: '2025-07-03 18:20',
    views: 876,
    comments: 31,
    likes: 22,
    isHot: false,
    image: null,
  },
  {
    id: 'post-005',
    category: 'news',
    categoryName: '업계소식',
    title: '2025년 하반기 나이트라이프 업계 트렌드 분석',
    content: '올해 하반기 나이트라이프 업계의 주요 트렌드를 분석해봤습니다. 모던바와 칵테일바의 성장세가 두드러지며, 특히 MZ세대를 타겟으로 한 컨셉 매장이 급증하고 있습니다. 또한 비대면 주문 시스템 도입이 가속화되고 있어요.',
    author: '업계분석가',
    authorAvatar: 'https://readdy.ai/api/search-image?query=professional%20business%20analyst%20portrait%20wearing%20glasses%20confident%20look%20warm%20lighting%20headshot%20dark%20background&width=80&height=80&seq=avatar-5&orientation=squarish',
    createdAt: '2025-07-03 10:00',
    views: 4521,
    comments: 67,
    likes: 203,
    isHot: true,
    image: 'https://readdy.ai/api/search-image?query=modern%20trendy%20cocktail%20bar%20interior%20with%20neon%20signs%20and%20contemporary%20design%20young%20crowd%20enjoying%20drinks%20warm%20ambient%20atmosphere&width=600&height=360&seq=comm-5&orientation=landscape',
  },
  {
    id: 'post-006',
    category: 'tips',
    categoryName: '꿀팁공유',
    title: '손님 응대 스킬 업그레이드하는 방법',
    content: '서비스업에서 가장 중요한 건 역시 손님 응대죠. 제가 7년간 일하면서 터득한 노하우를 공유합니다. 첫인상, 대화법, 컴플레인 처리까지 실전에서 바로 쓸 수 있는 팁들이에요.',
    author: '서비스프로',
    authorAvatar: 'https://readdy.ai/api/search-image?query=friendly%20professional%20service%20worker%20portrait%20warm%20smile%20elegant%20attire%20soft%20lighting%20headshot%20dark%20background&width=80&height=80&seq=avatar-6&orientation=squarish',
    createdAt: '2025-07-02 20:15',
    views: 2134,
    comments: 38,
    likes: 95,
    isHot: false,
    image: null,
  },
  {
    id: 'post-007',
    category: 'free',
    categoryName: '자유게시판',
    title: '야간 근무 후 컨디션 관리 어떻게 하세요?',
    content: '새벽까지 일하고 나면 다음 날 컨디션이 너무 안 좋은데, 다들 어떻게 관리하시나요? 수면 패턴이나 식단 관리 팁 있으면 공유해주세요.',
    author: '올빼미족',
    authorAvatar: 'https://readdy.ai/api/search-image?query=tired%20but%20cheerful%20young%20person%20portrait%20casual%20style%20warm%20expression%20soft%20lighting%20headshot%20dark%20background&width=80&height=80&seq=avatar-7&orientation=squarish',
    createdAt: '2025-07-02 16:45',
    views: 1678,
    comments: 42,
    likes: 67,
    isHot: false,
    image: null,
  },
  {
    id: 'post-008',
    category: 'review',
    categoryName: '업장후기',
    title: '이태원 모던바 소울 근무 후기 (6개월)',
    content: '이태원 모던바 소울에서 6개월간 바텐더로 일한 후기입니다. 외국인 손님이 많아서 영어 실력이 많이 늘었고, 다양한 칵테일을 배울 수 있었어요. 사장님도 좋으시고 팀 분위기도 괜찮습니다.',
    author: '글로벌바텐더',
    authorAvatar: 'https://readdy.ai/api/search-image?query=confident%20young%20bartender%20portrait%20with%20international%20vibe%20warm%20smile%20professional%20look%20headshot%20dark%20background&width=80&height=80&seq=avatar-8&orientation=squarish',
    createdAt: '2025-07-01 23:30',
    views: 1923,
    comments: 29,
    likes: 74,
    isHot: false,
    image: 'https://readdy.ai/api/search-image?query=cozy%20modern%20bar%20interior%20in%20Itaewon%20Seoul%20with%20international%20atmosphere%20warm%20lighting%20diverse%20crowd%20enjoying%20cocktails&width=600&height=360&seq=comm-8&orientation=landscape',
  },
  {
    id: 'post-009',
    category: 'qna',
    categoryName: '질문답변',
    title: '바텐더 자격증 따는 게 도움이 되나요?',
    content: '바텐더 자격증을 따려고 하는데, 실제로 취업할 때 도움이 되는지 궁금합니다. 자격증 있으신 분들 경험담 부탁드려요.',
    author: '자격증고민',
    authorAvatar: 'https://readdy.ai/api/search-image?query=studious%20young%20person%20portrait%20thoughtful%20expression%20casual%20style%20warm%20lighting%20headshot%20dark%20background&width=80&height=80&seq=avatar-9&orientation=squarish',
    createdAt: '2025-07-01 15:10',
    views: 1345,
    comments: 35,
    likes: 41,
    isHot: false,
    image: null,
  },
  {
    id: 'post-010',
    category: 'free',
    categoryName: '자유게시판',
    title: '오늘 손님한테 칭찬 받았어요 ㅎㅎ',
    content: '오늘 단골 손님이 제가 만든 칵테일이 여기서 제일 맛있다고 해주셨어요. 이런 말 한마디에 힘이 나네요. 다들 오늘도 화이팅!',
    author: '행복한바텐더',
    authorAvatar: 'https://readdy.ai/api/search-image?query=happy%20young%20bartender%20portrait%20beaming%20smile%20warm%20expression%20professional%20attire%20soft%20lighting%20headshot%20dark%20background&width=80&height=80&seq=avatar-10&orientation=squarish',
    createdAt: '2025-07-01 02:30',
    views: 892,
    comments: 18,
    likes: 156,
    isHot: false,
    image: null,
  },
];

export const popularTags = [
  '바텐더', '칵테일', '강남', '이태원', '모던바', '서버', '매니저',
  '신입', '이직', '급여', '면접팁', '야간근무', '자격증', '홍대',
];

export const topUsers = [
  { rank: 1, name: '칵테일마스터', score: 2840, avatar: 'https://readdy.ai/api/search-image?query=professional%20young%20bartender%20portrait%20with%20confident%20smile%20dark%20background%20warm%20lighting%20headshot%20professional%20photo&width=80&height=80&seq=avatar-1&orientation=squarish' },
  { rank: 2, name: '서비스프로', score: 2156, avatar: 'https://readdy.ai/api/search-image?query=friendly%20professional%20service%20worker%20portrait%20warm%20smile%20elegant%20attire%20soft%20lighting%20headshot%20dark%20background&width=80&height=80&seq=avatar-6&orientation=squarish' },
  { rank: 3, name: '업계분석가', score: 1890, avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20analyst%20portrait%20wearing%20glasses%20confident%20look%20warm%20lighting%20headshot%20dark%20background&width=80&height=80&seq=avatar-5&orientation=squarish' },
];
